export const TranslationType = {
    EQUIPMENT: 'equipment',
    ITEM: 'item',
    CASESPACK: 'casespack',
    COSMETIC: 'cosmetic',
    ITEMSHOP: 'itemshop',
    NPCS: 'npcs',
    MOBS: 'mobs',
    QUESTS: 'quests',
    OTHER: 'other'
} as const;

export const TranslationSpecialFieldType = {
    NAME: 'name',
    DESCRIPTION: 'description',
} as const;
